<template>
    <div class="all-height">
        <el-main class="all-height">

            <div class="operation-bar">
                <h1>供应商列表</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query(1)"></i>
                        <input type="text" v-model="keyword" placeholder="请输入供应商编号或名称"/>
                    </div>
                    <a href="javascript:void(0)" @click="sendNotice">发布公告</a>
                </div>
            </div>

            <div class="table-box">
                <el-table :data="vendorList"
                          height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                          @row-click="handleCurrentChange"
                >
                    <el-table-column width="150px" prop="vendorNo" label="供应商编号" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="250px" prop="vendorName" label="供应商名称" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="taxNo" label="税号" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="address" label="地址" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="bossName" label="法人" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="contact1" label="联系人一" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="phone1" label="电话一" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="contact2" label="联系人二" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="phone2" label="电话二" header-align="center" align="center"
                                     :show-overflow-tooltip="true">
                    </el-table-column>

                    <el-table-column width="80px" prop="isLock" label="状态" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="changeStatus(scope.row)" type="text">
                                <el-tag effect="dark" type="success" v-if="scope.row.isLock === 0">正常</el-tag>
                                <el-tag effect="dark" type="danger" v-else>禁用</el-tag>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column width="80px" label="发送消息" header-align="center" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-s-promotion" @click="sendMsg(scope.$index, scope.row)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column width="80px" label="用户查看" header-align="center" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-view" @click="viewAccount(scope.$index, scope.row)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column width="80px" label="签章上传" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-upload
                                action="/supplier-resource/system/user/uploadSign"
                                :data="params"
                                :headers="uploadHeaders"
                                :on-success="success"
                                :show-file-list="false"
                                :on-error="error"
                                multiple>
                                <el-button type="primary"><i class="el-icon-upload"></i></el-button>
                            </el-upload>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                        @size-change="changePageSize"
                        @current-change="changeCurrentPage"
                        :current-page="page.current"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>

        <el-dialog
            :title="msg_frmTitle"
            :visible.sync="dialogVisible"
            width="50%"
            @close="clearMsgDialog"
        >
            <el-row class="all-height">
                <el-col :span="18">
                    <el-form :model="msg_frmData" label-width="60px">
                        <el-form-item label="接收者" v-show="receiverVisible">
                            <el-input v-model="msg_frmData.receiver" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="标题">
                            <el-input v-model="msg_frmData.msgTitle" maxlength="80" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="内容">
                            <div class="textArea-box">
                                <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 31}"
                                          v-model="msg_frmData.msgContent" maxlength="1800" show-word-limit></el-input>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="6">
                    <div style="margin-left: 10px;padding-left: 10px;max-height: 500px">
                        <el-upload
                            ref="upload"
                            action="#"
                            :on-remove="handleRemove"
                            :file-list="fileShowList"
                            :http-request="uploadSectionFile"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">附件上传</el-button>
                        </el-upload>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearMsgDialog">取 消</el-button>
                <el-button type="primary" @click="submitMsg">确 定</el-button>
              </span>
        </el-dialog>

        <el-drawer
            title="用户信息"
            :visible.sync="drawer"
            direction="rtl"
            :with-header="false"
            custom-class="demo-drawer">
            <el-table :data="userList">
                <el-table-column property="username" label="账号" width="150" header-align="center" align="center"
                                 :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column property="manname" label="姓名" header-align="center" align="center"
                                 :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column label="是否在线" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.isOnline === 1">在线</el-tag>
                        <el-tag type="info" v-else>离线</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>

</template>

<script>
import {mapState} from 'vuex';
let token = window.sessionStorage.getItem('wh-access-token');
export default {
    name: 'account_management',
    data() {
        return {
            params: {
                vendorNo: ''
            },
            uploadHeaders: {Authorization: 'Bearer ' + token},
            keyword: '',
            fileList: [],
            fileShowList: [],
            drawer: false,
            labelWidth: '60px',
            dialogVisible: false,
            receiverVisible: true,
            msg_frmTitle: ''
        };
    },
    computed: {
        ...mapState('system/vendorManagement', ['vendorList', 'page', 'msg_frmData', 'userList'])
    },
    methods: {
        success(response, file, fileList) {
            if (response.code === '200') {
                this.$message.success('文件上传成功！');
            } else {
                this.$message.error('文件上传失败！' + response.message);

            }
        },
        error(err, file, fileList) {
            this.$message.error('文件上传失败！' + err.message);
        },
        handleCurrentChange(val) {
          this.params.vendorNo = val.vendorNo;
          console.log(this.params);
        },
        query(currentPage) {
            if (currentPage) {
                this.$store.commit('system/vendorManagement/SET_PAGE_CURRENT', currentPage);
            }
            this.$store.dispatch('system/vendorManagement/getVendorList', this.keyword);
        },
        sendNotice() {
            this.msg_frmTitle = '发布公告';
            this.receiverVisible = false;
            this.$store.commit('system/vendorManagement/SET_NOTICE_FRM_DATA', {currentUser: this.$store.state.login.currentUser});
            this.dialogVisible = true;
        },
        sendMsg(index, row) {
            this.msg_frmTitle = '发送消息';
            this.receiverVisible = true;
            this.$store.commit('system/vendorManagement/SET_MSG_FRM_DATA', {
                currentUser: this.$store.state.login.currentUser,
                row: row
            });
            this.dialogVisible = true;
        },
        submitMsg() {
            this.$refs.upload.submit();
            if (!this.$store.state.login.currentUser) {
                this.$message.error('用户已下线！！！');
                return;
            }
            this.$store.dispatch('system/vendorManagement/submitMsg', this.fileList).then((ret) => {
                if (ret.code === '200') {
                    this.dialogVisible = false;
                    this.$message.success('发送成功');
                } else {
                    this.$message.error(ret.data ? ret.data : ret.message);
                }
            });
        },
        viewAccount(index, row) {
            this.drawer = true;
            this.$store.dispatch('system/vendorManagement/getUserListByVendorId', {row: row});
        },
        changePageSize(val) {
            this.$store.commit('system/vendorManagement/SET_PAGE_SIZE', val);
            this.query();
        },
        changeCurrentPage(val) {
            this.$store.commit('system/vendorManagement/SET_PAGE_CURRENT', val);
            this.query();
        },
        changeStatus(row) {
            if (row.isLock === 0) {
                this.$store.dispatch('system/vendorManagement/changeVendorStatus', {id: row.id, isLock: 1})
                    .then((ret) => {
                        if (ret.code === '200') {
                            row.isLock = 1;
                        } else {
                            this.$message.error(ret.data ? ret.data : ret.message);
                        }
                    });
            }
            if (row.isLock === 1) {
                this.$store.dispatch('system/vendorManagement/changeVendorStatus', {id: row.id, isLock: 0})
                    .then((ret) => {
                        if (ret.code === '200') {
                            row.isLock = 0;
                        } else {
                            this.$message.error(ret.data ? ret.data : ret.message);
                        }
                    });
            }
        },
        handleRemove(file, fileList) {
            console.log(file);
            console.log(fileList);
        },
        uploadSectionFile(params) {
            this.fileList.push(params.file);
        },
        clearMsgDialog() {
            this.fileShowList = [];
            this.fileList = [];
            this.dialogVisible = false;
        }
    },
    created() {
        this.query();
    }
}

</script>

<style scoped>
.table-box {
    position: relative;
    margin-top: 5px;
    background-color: white;
    height: calc(100% - 35px);
    width: 100%;
}

.table-page {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
}

.el-table .el-button {
    padding: 0;
}

.cell i {
    font-size: 20px;
    cursor: pointer;
}

.cell i:hover {
    color: #5ED1FD;
}

.textArea-box {
    max-height: 300px;
    overflow-y: scroll;
}
</style>
